<template>
  <div id="contenedor-contrato-agregar-actividad">
    <v-form v-model="formularioValido" ref="registrarNuevaActividad">
      <v-card>
        <v-card-title class="secondary--text">
          Registrar nueva actividad
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mx-2"></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              Frente: <span class="font-weight-bold">{{ frente.descripcion }}</span>
            </v-col>
            <date-picker
              v-model="actividad.fecha"
              label="Fecha"
              cols="6"
              :rules="[mixReglas.requerido]"
            >
            </date-picker>
            <custom-text-area
              v-model="actividad.descripcion"
              cols="12"
              label="Descripción"
              rows="4"
              :rules="[mixReglas.requerido]"
            >
            </custom-text-area>
            <custom-select
              cols="4"
              v-model="actividad.verificacionSeguridad"
              label="Verificación de seguridad"
              :items="selectItems"
              item-text="text"
              item-value="value"
              prepend-inner-icon="mdi-shield-check-outline"
              :rules="[mixReglas.requerido]"
            >
            </custom-select>
            <custom-select
              cols="4"
              v-model="actividad.higieneLimpiezaTrabajos"
              label="Higiene y limpieza"
              :items="selectItems"
              item-text="text"
              item-value="value"
              prepend-inner-icon="mdi-broom"
              :rules="[mixReglas.requerido]"
            >
            </custom-select>
            <custom-select
              cols="4"
              v-model="actividad.inventarioInsumosPresentes"
              label="Inventario de insumos"
              :items="selectItems"
              item-text="text"
              item-value="value"
              prepend-inner-icon="mdi-bulldozer"
              :rules="[mixReglas.requerido]"
            >
            </custom-select>
          </v-row>
          <v-divider></v-divider>
          <!-- Fotos de la actividad -->
          <div id="contenedor-album-fotografico">
            <v-row>
              <!-- Listado de imagenes -->
              <template v-for="(imagen, index) in imagenes">
                <template>
                  <v-col cols="auto" class="pa-1" :key="`imagen-${index}`">
                    <v-img
                      :src="imagen"
                      height="180"
                      width="180"
                      contain
                      class="blue-grey darken-4"
                    >
                      <div class="contenedor-imagenes-remover-imagen">
                        <v-btn small icon dark @click="removerImagen(index)">
                          <v-icon>
                            mdi-close-circle
                          </v-icon>
                        </v-btn>
                      </div>
                    </v-img>
                  </v-col>
                </template>
              </template>
              <!-- Seleccionar imagen -->
              <v-col cols="auto">
                <div class="contenedor-imagenes-agregar" @click="$refs.seleccionarAnexo.click()">
                  <v-img src="@/assets/add-img-img.png" contain height="100" width="100"> </v-img>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
          </custom-button>
          <custom-button
            @click="mixAgregarContratoActividad"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
    <input
      type="file"
      ref="seleccionarAnexo"
      id="anexo"
      class="d-none"
      accept="image/jpeg, image/png, image/bmp"
      multiple
      @change="preCargarImagenes"
    />
  </div>
</template>

<script>
import DatePicker from '@/components/inputs/DatePicker.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixDiarioActividades from './mixDiarioActividades';

export default {
  name: 'ContratoAgregarActividad',
  mixins: [mixDiarioActividades],
  props: {
    idContrato: {
      type: String,
      required: true,
    },
    idFrente: {
      type: String,
      required: true,
    },
    frente: {
      type: Object,
      required: true,
    },
    tipo: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  components: {
    DatePicker,
    CustomSelect,
    CustomTextArea,
    CustomButton,
  },
  data() {
    return {
      selectItems: [
        { value: 1, text: 'BIEN' },
        { value: 2, text: 'REGULAR' },
        { value: 3, text: 'MAL' },
      ],
      formularioValido: false,
      enviandoFormulario: false,
      imagenes: [],
      actividad: {
        idContrato: this.idContrato,
        idContratoFrente: this.idFrente,
        descripcion: '',
        fecha: new Date().toISOString().substr(0, 10),
        imagenes: [],
        verificacionSeguridad: 1,
        higieneLimpiezaTrabajos: 1,
        inventarioInsumosPresentes: 1,
      },
    };
  },

  methods: {
    preCargarImagenes() {
      const { imagenes } = this.actividad;
      // get las fotos
      const fileInput = document.getElementById('anexo');
      imagenes.push(...fileInput.files);

      for (let i = 0; i < fileInput.files.length; i += 1) {
        const url = URL.createObjectURL(fileInput.files[i]);
        this.imagenes.push(url);
      }
    },
    removerImagen(index) {
      this.imagenes.splice(index, 1);
      this.actividad.imagenes.splice(index, 1);
    },
    limpiarFormulario() {
      this.imagenes = [];
      this.actividad.descripcion = '';
      this.actividad.comentarioFotografico = '';
      this.actividad.esProblema = false;
      this.actividad.fecha = new Date().toISOString().substr(0, 10);
      this.actividad.imagenes = [];
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
  watch: {
    tipo: {
      handler(tipo) {
        this.actividad.tipo = tipo;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.contenedor-imagenes-vista-previa {
  position: relative;
}
.contenedor-imagenes-remover-imagen {
  position: absolute;
  top: 5px;
  right: 5px;
}
.contenedor-imagenes-agregar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ccc;
  height: 180px;
  width: 180px;
  padding: 1em;
  border-radius: 0.5rem;
  cursor: pointer;
}
.contenedor-imagenes-agregar:hover {
  border: 2px solid #ccc;
}
</style>
